/// <amd-module name="Feed/Legacy/Protocols/Common/IConnectToFeedProps" />
import { IVssPageContext } from "VSS/Platform/Context";

import { Feed } from "Feed/Common/Contracts/Feed";
import { HubAction } from "Feed/Legacy/Types/IHubState";

export interface IConnectToFeedProps {
    pageContext: IVssPageContext;
    feed: Feed;
    hubAction: HubAction;
}
